import { FeatureFlag } from '@/modules/App/featureFlags'
import { useFeatureFlags } from '@/modules/App/useFeatureFlags'
import { watch, type Ref } from 'vue'
import { useFolderStore } from './useFolderStore'

/**
 * Loads the current workspace's folder trees into the folder store when changing
 * workspace.
 */
export const useLoadFolderTrees = (workspaceId: Ref<string>) => {
  const folderStore = useFolderStore()
  const foldersAreEnabled = useFeatureFlags(FeatureFlag.AGENT_FOLDERS)
  watch(
    [workspaceId, foldersAreEnabled],
    ([newWorkspaceId, newFoldersAreEnabled]) => {
      if (!newFoldersAreEnabled) {
        return
      }
      folderStore.$reset()
      folderStore.loadFolderTrees(newWorkspaceId)
    },
    {
      immediate: true,
    },
  )
}
